export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: 'en',
  strictMessage: false, // 关闭消息语法强校验
  missingWarn: false,
  fallbackWarn: false,
}))
